/**
 * Returns random integer from 0 to number, not exceeding certain number of digits
 * @param signNumber - number of digits
 */
export function random(signNumber: number = 15): number {
  signNumber = signNumber <= 15 ? signNumber : 15;

  return Math.round(Math.random() * Math.pow(10, signNumber));
}
